import {toArray, compact, entries, flow, join} from '@dovca/toolbox';
import {isEmptyOrFalsy} from '@/utils/isEmptyOrFalsy';

export class GsoaParamBuilder<ParamNames extends string = never> {
	state: Record<ParamNames, string> = {} as Record<ParamNames, string>;

	static AND(values: string[]): string {
		return flow(
			values,
			compact,
			join(';;'),
		);
	}

	static inArray(name: string, value: string | string[] | null | undefined): string {
		const sanitizedValue = flow(
			value ?? [],
			toArray,
			join(','),
		);

		return GsoaParamBuilder.binaryOperator(name, 'in', sanitizedValue);
	}

	static equal = GsoaParamBuilder.makeBinaryOperator('eq');
	static greaterThan = GsoaParamBuilder.makeBinaryOperator('gt');
	static lessThan = GsoaParamBuilder.makeBinaryOperator('lt');
	static greaterOrEqual = GsoaParamBuilder.makeBinaryOperator('ge');
	static lessOrEqual = GsoaParamBuilder.makeBinaryOperator('le');

	add<NewName extends string>(name: NewName, value: string): GsoaParamBuilder<ParamNames | NewName> {
		const builder = this as GsoaParamBuilder<ParamNames | NewName>;
		builder.state[name] = value;
		return builder;
	}

	build(): Partial<Record<ParamNames, string>> {
		const result: Partial<Record<ParamNames, string>> = {};

		for (const [key, value] of entries(this.state)) {
			if (!isEmptyOrFalsy(value)) {
				result[key as keyof typeof result] = value;
			}
		}

		return result;
	}

	private static binaryOperator(name: string, operator: string, value: any): string {
		return isEmptyOrFalsy(value)
			? ''
			: `${name}:${operator} ${value}`;
	}

	private static makeBinaryOperator(op: string) {
		return (name: string, value: any) => GsoaParamBuilder.binaryOperator(name, op, value);
	}
}
